/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Dashboard Series Naming";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p><_components.strong>{"Series naming"}</_components.strong>{": Select a method to filter for metrics:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li><_components.strong>{"Labels"}</_components.strong>{" require a "}<_components.strong>{"Naming pattern"}</_components.strong>{". Use "}<_components.code>{"{{ label_name }}"}</_components.code>{" to include a\nlabel value. For example, "}<_components.code>{"{{ env }}"}</_components.code>{" will be replaced with values like staging-1, prod-1."}</_components.li>{"\n"}<_components.li><_components.strong>{"Regex"}</_components.strong>{": Use a "}<_components.a href="/investigate/querying/regular-expressions">{"regular expression"}</_components.a>{"\nin the "}<_components.strong>{"Regex"}</_components.strong>{" text field to match a time series. You can also use a\n"}<_components.strong>{"Naming pattern"}</_components.strong>{" to rename series using capture groups."}</_components.li>{"\n"}</_components.ul></>;
}

export default MDXLayout